enum BaseRoutePath {
  HOME = '/',
  PROFILE = '/profile',
  LOGIN = '/login',
  ERROR = '/error',
  NOT_FOUND = '/404',
  NO_ACCESS = '/403',
  ACCESS_FORBIDDEN = '/402', // todo update
  MAINTENANCE = '/maintenance',
  ANY = '*',
  CONTACTS = '/contacts',
}

export default BaseRoutePath;
